import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const load = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try {
      const { data } = await api.get("/wishlist");
      setIds(data.product_ids || []);
    } catch { /* ignore */ }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (product_id) => {
    if (!user) { toast.error("Sign in to save favourites"); return false; }
    const { data } = await api.post("/wishlist/toggle", { product_id });
    setIds(data.product_ids);
    toast.success(data.wishlisted ? "Saved to favourites" : "Removed from favourites");
    return true;
  };

  const has = (id) => ids.includes(id);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, load, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
